import { useState } from "react";
import { CONTACT, IMAGES } from "../../data";
import { scrollToId } from "../../lib/scroll";
import { Phone, Mail, MapPin } from "lucide-react";
import { LegalModal } from "./LegalModal";

const year = new Date().getFullYear();

const servicesCol = ["Ground Expedite", "Cross-Border Freight", "Cargo-Van Delivery", "Direct-Drive Service", "Recurring Routes", "Airport Freight Coordination"];
const companyCol = [
  { label: "About", target: "about" },
  { label: "Industries", target: "industries" },
  { label: "Course Announcement", target: "training" },
  { label: "FAQ", target: "faq" },
  { label: "Contact", target: "quote" },
];

export const Footer = () => {
  const [legal, setLegal] = useState(null);
  return (
    <footer className="bg-oyf-charcoal text-white" data-testid="footer">
      <div className="container-oyf py-16 grid md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <img src={IMAGES.logo} alt="One York Freight logo" className="h-9 w-auto bg-white rounded p-1.5" />
          <p className="mt-5 text-sm text-white/60 leading-relaxed max-w-xs">
            Expedited cargo-van logistics and Canada–U.S. cross-border freight coordination.
          </p>
        </div>
        <div>
          <h4 className="font-display font-bold text-oyf-yellow text-sm tracking-widest uppercase mb-4">Services</h4>
          <ul className="space-y-2.5">
            {servicesCol.map((s) => (
              <li key={s}><button onClick={() => scrollToId("services")} className="text-sm text-white/70 hover:text-white transition-colors">{s}</button></li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="font-display font-bold text-oyf-yellow text-sm tracking-widest uppercase mb-4">Company</h4>
          <ul className="space-y-2.5">
            {companyCol.map((c) => (
              <li key={c.label}><button onClick={() => scrollToId(c.target)} className="text-sm text-white/70 hover:text-white transition-colors">{c.label}</button></li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="font-display font-bold text-oyf-yellow text-sm tracking-widest uppercase mb-4">Contact</h4>
          <ul className="space-y-3">
            <li><a href={CONTACT.tel} className="flex items-center gap-2.5 text-sm text-white/80 hover:text-oyf-yellow transition-colors"><Phone size={15} /> {CONTACT.phone}</a></li>
            <li><a href={`mailto:${CONTACT.email}`} className="flex items-center gap-2.5 text-sm text-white/80 hover:text-oyf-yellow transition-colors"><Mail size={15} /> {CONTACT.email}</a></li>
            <li className="flex items-center gap-2.5 text-sm text-white/60"><MapPin size={15} /> Serving Canada and the United States</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-oyf py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/50">© {year} One York Freight. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <button onClick={() => setLegal("privacy")} className="text-xs text-white/60 hover:text-oyf-yellow transition-colors" data-testid="footer-privacy">Privacy Policy</button>
            <button onClick={() => setLegal("terms")} className="text-xs text-white/60 hover:text-oyf-yellow transition-colors" data-testid="footer-terms">Terms and Conditions</button>
            <button onClick={() => setLegal("accessibility")} className="text-xs text-white/60 hover:text-oyf-yellow transition-colors" data-testid="footer-accessibility">Accessibility</button>
          </div>
        </div>
      </div>
      <LegalModal type={legal} onClose={() => setLegal(null)} />
    </footer>
  );
};
